import { ReactComponent } from './number-2-xs.svg';
export const Number2IconXs = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=number-2-xs.js.map